import { render } from "./invoice-history.vue?vue&type=template&id=1164d202&lang=pug"
import script from "./invoice-history.vue?vue&type=script&lang=js"
export * from "./invoice-history.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__